import { $, $$, getTopPosition } from 'utils/dom';
import Bus from 'modules/event-bus';
import AniScroll from 'modules/ani-scroll';

class ToggleText {
  constructor(props) {
    this.container = props.container;
    this.toggleBtn = $('.btn', this.container);
    this.textField = $('.introtext__text', this.container);
    this.overlay = $('.introtext__button-wrapper', this.container);
    this.visibleTextHeight = 469;
    this.textIsSmallerThanVisibleHeight = false;
  }

  setVisibilityClasses = () => {
    if (this.textField.clientHeight < this.visibleTextHeight) {
      this.overlay.classList.add('is-hidden');
      this.textField.classList.remove('is-collapsed');
    } else {
      this.overlay.classList.remove('is-hidden');
      this.textField.classList.add('is-collapsed');
    }
  };

  toggleText = () => {
    const isCollapsed = this.textField.classList.contains('is-collapsed');

    if (!isCollapsed) {
      const elementTopPosition = getTopPosition(this.container);
      const header = $('.header');
      let scrollToPosition;

      header
        ? (scrollToPosition = elementTopPosition - header.offsetHeight)
        : (scrollToPosition = elementTopPosition);
      AniScroll(scrollToPosition, 500, 'easeOutQuad');
    }

    this.textField.classList.toggle('is-collapsed');
    this.overlay.classList.toggle('is-open');
  };

  onResize = () => {
    if (this.textField.clientHeight < this.visibleTextHeight) {
      if (!this.textIsSmallerThanVisibleHeight) {
        this.setVisibilityClasses();
        this.overlay.classList.remove('is-open');
        this.textIsSmallerThanVisibleHeight = true;
      }
    } else {
      if (this.textIsSmallerThanVisibleHeight) {
        this.setVisibilityClasses();
        this.overlay.classList.remove('is-open');
        this.textIsSmallerThanVisibleHeight = false;
      }
    }
  };

  bindEvents = () => {
    this.toggleBtn.addEventListener('click', this.toggleText);
    Bus.subscribe('resize', 'ToggleText', this.onResize);
  };

  init = () => {
    this.setVisibilityClasses();
    this.bindEvents();
  };
}

const toggleText = $$('.introtext--toggle');
toggleText.length &&
  toggleText.forEach(text => {
    new ToggleText({
      container: text,
    }).init();
  });
